module.exports = __webpack_public_path__ + "img/fa975904e5cf4f82d7b1dddcafc4fb59.jpg";